import * as React from 'react'

import { ChevronDownIcon } from 'lucide-react'
import { inject, observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import ColorPickerWrapper from '~/client/src/shared/components/ColorPicker/ColorPickerWrapper'
import InitialState from '~/client/src/shared/stores/InitialState'
import { SITEMAP_ITEMS_COLORS_VALUES } from '~/client/src/shared/utils/SitemapItemsColors'

import './SitemapItemsColorPicker.scss'

interface IProps {
  value: string

  className?: string
  opacity?: number
  disabled?: boolean
  state?: InitialState

  onChange(color: string): void
}

@inject('state')
@observer
export default class SitemapItemsColorPicker extends React.Component<IProps> {
  public render() {
    const { value, className, onChange, disabled } = this.props

    return (
      <div
        className={classList({
          'sitemap-items-color-picker': true,
          'tw:pointer-events-none tw:opacity-50': disabled,
          [className]: !!className,
        })}
      >
        <ColorPickerWrapper
          disabled={disabled}
          value={value}
          colors={this.colors}
          onChange={onChange}
          customColorPickerButton={this.renderColorPickerButton()}
        />
      </div>
    )
  }

  private get colors() {
    return [
      ...SITEMAP_ITEMS_COLORS_VALUES,
      ...(this.props.state.projectColoringOptions.colors || []),
    ]
  }

  private renderColorPickerButton = (): JSX.Element => {
    const { value, opacity } = this.props

    return (
      <div className="inline-block relative">
        <div className="row value-container relative">
          <div
            className="no-grow color-option value"
            style={{ backgroundColor: value, opacity }}
          />
          <div className="opacity-background color-option value" />
          <div className="row y-center x-center arrow-container">
            <ChevronDownIcon size={12} className="no-grow" />
          </div>
        </div>
      </div>
    )
  }
}
